import type { FrontendModule } from '@/lib/types'
import { TimesheetPage } from './pages/TimesheetPage'

/**
 * Moduł `timesheet` — „Rejestracja czasu" (moduł OPCJONALNY, env `MODULES_ENABLED`).
 *
 * Trasa `/czas` musi być identyczna z `NavItem.route` w manifeście backendu
 * (`app/modules/timesheet/module.py`); nawigacja pochodzi wyłącznie z `/api/me/context`.
 */
export const timesheetModule: FrontendModule = {
  key: 'timesheet',
  routes: [{ path: 'czas', element: <TimesheetPage /> }],
}

export default timesheetModule
